<template>
    <v-col cols="12" class="pr-6">
        <v-row>
            <v-col cols="12" align="start" class="ml-4 mt-4 color-text text-h5">
                {{ $t('profile.abilities') }}
            </v-col>
            <v-col cols="12" align="center">
                <v-card
                    class="pa-6"
                    elevation="12"
                    :height="height"
                >
                    <v-row justify="center">
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-btn-toggle
                                v-model="rank"
                                tile
                                group
                                borderless
                                mandatory
                                dense
                                @change="changeRank"
                            >
                                <v-btn value="4" class="px-0 mx-2 color-text text-subtitle-1 font-weight-bold" small :disabled="!progressReady">
                                    {{ $t('profile.global_progress_rank[0]') }}
                                </v-btn>
                                <v-btn value="8" class="px-0 mx-2 color-text text-subtitle-1 font-weight-bold" small :disabled="!progressReady">
                                    {{ $t('profile.global_progress_rank[1]') }}
                                </v-btn>
                                <v-btn value="12" class="px-0 mx-2 color-text text-subtitle-1 font-weight-bold" small :disabled="!progressReady">
                                    {{ $t('profile.global_progress_rank[2]') }}
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="mt-10">
                        <v-col cols="12" lg="4" class="text-left text-subtitle text-md-h5 font-weight-regular">
                            <v-row justify="space-around" class="pa-0 ma-0">
                                <vue-ellipse-progress
                                    :loading="!progressReady"
                                    :progress="selectedProgress.localizar"
                                    :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?130:130"
                                    :legend="true"
                                    emptyColor="#FFC2C7"
                                    :color="gradientOne"
                                    thickness="10"
                                    emptyThickness="10"
                                    dot="25 #FF051B"
                                    >
                                    <span slot="legend-value">%</span>
                                </vue-ellipse-progress>
                                <vue-ellipse-progress
                                    :loading="!progressReady"
                                    :progress="selectedProgress.integrar"
                                    :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?130:130"
                                    :legend="true"
                                    emptyColor="#E4DFF7"
                                    :color="gradientTwo"
                                    thickness="10"
                                    emptyThickness="10"
                                    dot="25 #6F55D0"
                                    >
                                    <span slot="legend-value">%</span>
                                </vue-ellipse-progress>
                            </v-row>
                            <v-row justify="center" class="pa-0 ma-0">
                                <vue-ellipse-progress
                                    :loading="!progressReady"
                                    :progress="selectedProgress.reflexionar"
                                    :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?130:130"
                                    :legend="true"
                                    emptyColor="#D2E4F4"
                                    :color="gradientThree"
                                    thickness="10"
                                    emptyThickness="10"
                                    dot="25 #1785E8"
                                    class="ability-3"
                                    >
                                    <span slot="legend-value">%</span>
                                </vue-ellipse-progress>
                            </v-row>
                        </v-col>
                        <v-col cols="12" lg="8" class="mt-sm-6 mt-lg-0 py-0 text-left text-subtitle-2 text-md-subtitle-1 text-xl-h6 color-text">
                            <v-row>
                                <v-img src="/img/user/ray-1.svg"
                                    max-height="35"
                                    max-width="35"
                                    class="mt-4 mx-3 mx-md-6"
                                ></v-img>
                                <v-col cols="9" md="10" class="pa-0">
                                    <span class="font-weight-bold">
                                        {{ $t('profile.abilityOne.title') }}
                                    </span>
                                    <p v-html="$t('profile.abilityOne.desc', [ getLevel(selectedProgress.localizar) ])">
                                    </p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-img src="/img/user/ray-2.svg"
                                    max-height="35"
                                    max-width="35"
                                    class="mt-4 mx-3 mx-md-6"
                                ></v-img>
                                <v-col cols="9" md="10" class="pa-0">
                                    <span class="font-weight-bold">
                                        {{ $t('profile.abilityTwo.title') }}
                                    </span>
                                    <p v-html="$t('profile.abilityTwo.desc', [ getLevel(selectedProgress.integrar) ])">
                                    </p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-img src="/img/user/ray-3.svg"
                                    max-height="35"
                                    max-width="35"
                                    class="mt-4 mx-3 mx-md-6"
                                ></v-img>
                                <v-col cols="9" md="10" class="pa-0">
                                    <span class="font-weight-bold">
                                        {{ $t('profile.abilityThree.title') }}
                                    </span>
                                    <p v-html="$t('profile.abilityThree.desc', [ getLevel(selectedProgress.reflexionar) ])">
                                    </p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

export default {
    props: {
        progress: {
            type: Array
        }
    },
    computed: {
        height() {
            if (this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm) {
                return 750
            }
            if (this.$vuetify.breakpoint.md) {
                return 730
            }
            if (this.$vuetify.breakpoint.xl) {
                return 400
            }
            return 430
        },
    },
    data() {
        return {
            gradientOne: {
                radial: false,
                colors: [
                    {
                        color: '#FF707D',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FF051B',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            },
            gradientTwo: {
                radial: false,
                colors: [
                    {
                        color: '#A58DFF',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#6F55D0',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            },
            gradientThree: {
                radial: false,
                colors: [
                    {
                        color: '#57AFFF',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#1785E8',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            },
            progressReady: false,
            rank: '4',
            selectedProgress: {
                index: 0,
                localizar: 0,
                reflexionar: 0,
                integrar: 0
            }
        }
    },
    methods: {
        changeRank () {
            if (this.rank === '12') {
                // eslint-disable-next-line prefer-destructuring
                this.selectedProgress = this.progress[2]
            }
            if (this.rank === '8') {
                // eslint-disable-next-line prefer-destructuring
                this.selectedProgress = this.progress[1]
            }
            if (this.rank === '4') {
                // eslint-disable-next-line prefer-destructuring
                this.selectedProgress = this.progress[0]
            }
            this.progressReady = true
        },
        getLevel (progress) {
            if (progress <= 33) {
                return this.$t('profile.abilityLevels[0]')
            }
            if (progress > 33 && progress <= 66) {
                return this.$t('profile.abilityLevels[1]')
            }
            return this.$t('profile.abilityLevels[2]')
        }
    },
    watch: {
        progress() {
            this.changeRank()
        }
    }
}
</script>
<style scoped>
.ability-3 {
    margin-top: -15px;
}
.color-text {
    color: #4A3216;
}
.v-card {
    border-radius: 20px;
}
.v-btn-toggle>.v-btn.v-btn--active {
    border-bottom: 5px solid #FF6F3A;
    color: #4A3216;
    opacity: 1;
}
.v-btn:before {
    background-color: white;
}
.v-btn {
    text-transform: none;
}
</style>